
// interships
export const GET_INTERNSHIPS = "/internships";
export const ADD_NEW_INTERNSHIP = "/internships";
export const UPDATE_INTERNSHIP = "/internships";
export const DELETE_INTERNSHIP = "/internships";


